module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/156.9e69a3e4.png";